<div class="sidebar">
  <div>
    <ul class="nav nav-pills nav-stacked">
      <li class="fade-container">
        <div class="right-fade-to-light-grey"></div>
        <div class="expandable-header" (click)="toggleBaseline()">
          <a anessaTranslation="RESULTS.SECTIONS.BASELINE_RESULTS"
             class="heading"
          ></a>
          <i class="material-icons">
            {{ (isBaselineExpanded() ? 'expand_less' : 'expand_more') }}
          </i>
        </div>
        <ul *ngIf="isBaselineExpanded()" class="nav sub-nav nav-pills nav-stacked">
          <li routerLinkActive="active">
            <a anessaTranslation="RESULTS.SECTIONS.SUMMARY"
               class="text-indent"
               routerLink="/results/baseline/summary"
            ></a>
          </li>
          <li routerLinkActive="active">
            <a anessaTranslation="RESULTS.SECTIONS.DETAILED"
               class="text-indent end-of-group"
               routerLink="/results/baseline/summary-detailed"
            ></a>
          </li>
          <li routerLinkActive="active">
            <a anessaTranslation="RESULTS.SECTIONS.TECHNICAL"
               class="text-indent"
               routerLink="/results/baseline/technical"
            ></a>
          </li>
          <li routerLinkActive="active">
            <a anessaTranslation="RESULTS.SECTIONS.FEEDSTOCK_BREAKDOWN"
               class="text-indent"
               routerLink="/results/baseline/feedstock-breakdown"
            ></a>
          </li>
          <li routerLinkActive="active">
            <a anessaTranslation="RESULTS.SECTIONS.PROJECT_FLOW_DIAGRAM"
               class="text-indent end-of-group"
               routerLink="/results/baseline/flow-diagram"
            ></a>
          </li>
          <li routerLinkActive="active" *ngIf="showFinancial">
            <a anessaTranslation="RESULTS.SECTIONS.FINANCIAL_GENERAL"
               class="text-indent"
               routerLink="/results/baseline/financial-general"
            ></a>
          </li>
          <li *ngIf="!showFinancial">
            <a anessaTranslation="RESULTS.SECTIONS.FINANCIAL_GENERAL"
               class="text-indent hidelink"
            ></a>
          </li>
          <li routerLinkActive="active" *ngIf="showFinancial">
            <a anessaTranslation="RESULTS.SECTIONS.FINANCIAL_METRICS"
               class="text-indent"
               routerLink="/results/baseline/financial-metrics"
            ></a>
          </li>
          <li *ngIf="!showFinancial">
            <a anessaTranslation="RESULTS.SECTIONS.FINANCIAL_METRICS"
               class="text-indent hidelink fade-light-grey-right"
            ></a>
          </li>
          <li routerLinkActive="active" *ngIf="showFinancial">
            <a anessaTranslation="RESULTS.SECTIONS.DEBT_SCHEDULE"
               class="text-indent"
               routerLink="/results/baseline/debt-schedule"
            ></a>
          </li>
          <li *ngIf="!showFinancial">
            <a anessaTranslation="RESULTS.SECTIONS.DEBT_SCHEDULE"
               class="text-indent hidelink"
            ></a>
          </li>
          <li routerLinkActive="active" *ngIf="showFinancial">
            <a anessaTranslation="RESULTS.SECTIONS.INCOME_STATEMENT"
               class="text-indent"
               routerLink="/results/baseline/income-statement"
            ></a>
          </li>
          <li *ngIf="!showFinancial">
            <a anessaTranslation="RESULTS.SECTIONS.INCOME_STATEMENT"
               class="text-indent hidelink"
            ></a>
          </li>
          <li routerLinkActive="active" *ngIf="showFinancial">
            <a anessaTranslation="RESULTS.SECTIONS.CASH_FLOW_ANALYSIS"
               class="text-indent"
               routerLink="/results/baseline/cash-flow-analysis"
            ></a>
          </li>
          <li *ngIf="!showFinancial">
            <a anessaTranslation="RESULTS.SECTIONS.CASH_FLOW_ANALYSIS"
               class="text-indent hidelink"
            ></a>
          </li>
<!--          <li routerLinkActive="active">-->
<!--            <a anessaTranslation="RESULTS.SECTIONS.INPUT_SUMMARY"-->
<!--               class="text-indent"-->
<!--               routerLink="/results/baseline/input-summary"-->
<!--            ></a>-->
<!--          </li>-->
        </ul>
      </li>

      <li *ngIf="isSensitivityAvailable()" class="fade-container">
        <div class="right-fade-to-light-grey"></div>
        <div class="expandable-header" (click)="toggleSensAnalysis()">
          <a anessaTranslation="RESULTS.SECTIONS.SENSITIVITY_ANALYSIS"
             class="heading"></a>
          <i class="material-icons">
            {{ (isSensAnalysisExpanded() ? 'expand_less' : 'expand_more') }}
          </i>
        </div>
        <ul *ngIf="isSensAnalysisExpanded()" class="nav sub-nav nav-pills nav-stacked">
          <li routerLinkActive="active">
            <a anessaTranslation="RESULTS.SECTIONS.INPUT_SELECTION"
               class="text-indent"
               routerLink="/results/sensitivity/input-selection"
            ></a>
          </li>
          <li routerLinkActive="active">
            <a anessaTranslation="RESULTS.SECTIONS.RESULT_GRAPH"
               class="text-indent"
               routerLink="/results/sensitivity/sensitivity-results"
            ></a>
          </li>
        </ul>
      </li>
      <li class="fade-container">
        <div class="right-fade-to-light-grey"></div>
        <div class="expandable-header" (click)="toggleScenarioComp()">
          <a anessaTranslation="RESULTS.SECTIONS.SCENARIO_COMPARISON"
             class="heading"></a>
          <i class="material-icons">
            {{ (isScenarioCompExpanded() ? 'expand_less' : 'expand_more') }}
          </i>
        </div>
        <ul *ngIf="isScenarioCompExpanded()" class="nav sub-nav nav-pills nav-stacked">
          <li routerLinkActive="active">
            <a anessaTranslation="RESULTS.SECTIONS.SCENARIO_ENTRY"
               class="text-indent"
               routerLink="/results/scenario/scenario"
            ></a>
          </li>
          <li routerLinkActive="active">
            <a anessaTranslation="RESULTS.SECTIONS.RESULTS"
               class="text-indent"
               routerLink="/results/scenario/results"
            ></a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>
